export default __webpack_public_path__ + "static/media/esrp2.f1eb8161.svg";